import RankingsPage from './RankingsPage';
import VoteNotification from './VoteNotification';
import VotesModal from './VotesModal';
import Voters from './Voters';
import RankingImage from './RankingImage';

export const components = {
  RankingImage,
  RankingsPage,
  VoteNotification,
  VotesModal,
  Voters,
};
